type ArticleType = 'podcast' | 'video' | 'image'

/**
 * Determine the article type based on the media elements present in the DOM
 * @returns {ArticleType} The detected article type
 */
export function getArticleTypeFromMedia(): ArticleType {
	const hasAudio = document.querySelector('.articleMedia .articleMedia-audio')
	const hasVideo = document.querySelector('.articleMedia .articleMedia-video')

	if (hasAudio) {
		return 'podcast'
	}

	if (hasVideo) {
		return 'video'
	}

	return 'image'
}
